import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AdobeLaunchService } from '../shared/services/adobe-launch.service';
import { PAGE_TITLES, resolveSupportedLang } from '../shared/config/localized-paths';
import { environment } from '../../environments/environment';
import {
  buildHowItWorksContent,
  buildProgramBenefitsContent,
  buildTestimonialsContent,
  PRODUCT_INTRO_BANNER_ASSETS,
  ProductHowItWorksContent,
  ProductProgramBenefitsContent,
  ProductTestimonialsContent,
} from './invest.content';

@Component({
  selector: 'invest',
  templateUrl: './invest.component.html',
  styleUrls: ['./invest.component.scss'],
})
export class InvestComponent implements OnInit {
  public readonly introBannerAssets = PRODUCT_INTRO_BANNER_ASSETS;
  public productHowItWorksContent!: ProductHowItWorksContent;
  public productProgramBenefitsContent!: ProductProgramBenefitsContent;
  public productTestimonialsContent!: ProductTestimonialsContent;

  public readonly investRegisterUrl: string = `${environment.investmentUiBaseUrl}/register`;

  constructor(
    private readonly adobeLaunchService: AdobeLaunchService,
    private readonly translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.productHowItWorksContent = buildHowItWorksContent((key) =>
      this.translateService.instant(key),
    );

    this.productProgramBenefitsContent = buildProgramBenefitsContent((key) =>
      this.translateService.instant(key),
    );

    this.productTestimonialsContent = buildTestimonialsContent((key) =>
      this.translateService.instant(key),
    );

    const lang = resolveSupportedLang(this.translateService.currentLang);
    this.adobeLaunchService.trackPageView({
      pageTitle: PAGE_TITLES[lang].invest,
    });
  }
}
